import { Injectable, inject } from '@angular/core';
import { PointToGeoJsonHandler, TransformationService } from '@luzula/luzula-lib';
import { AufnahmePunktDocument, bodenformLabelString } from '../../data-model';

/**
 * Handler für die Konvertierung von AufnahmePunktDocument zu GeoJSON.
 * Wird vom LayerService für den GeoJSON-Export verwendet.
 */
@Injectable({ providedIn: 'root' })
export class BohrpunktGeoJsonHandler implements PointToGeoJsonHandler<AufnahmePunktDocument> {
	private ts = inject(TransformationService);

	/**
	 * Konvertiert ein Dokument zu GeoJSON-Properties.
	 */
	toGeoJsonProperties(bp: AufnahmePunktDocument): Record<string, any> {
		return {
			id: bp._id,
			nummer: bp.header.nummer,
			type: bp.type,
			bodenform: bodenformLabelString(bp),
			forstamt: bp.header.forstamt,
			revier: bp.header.revier,
			kartierer: bp.header.aufnahme?.kartierer,
			datum: bp.header.aufnahme?.datum,
			bemerkungen: bp.header.bemerkungen
		};
	}

	/**
	 * Liefert die Koordinaten für das GeoJSON-Geometry [lng, lat].
	 */
	getCoordinates(bp: AufnahmePunktDocument): [number, number] {
		const latLng = this.ts.from(bp.header.koordinaten);
		return [latLng.lng, latLng.lat];
	}
}
